<div *ngIf="loaded">
    <div #ps class="list relative pe-4" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }">
        <div class="d-flex g-0">
            <div class="text-nowrap pe-1">
                <div
                    *ngFor="let episode of episodes; let i = index"
                    [elementDataTest]="elementDataTestEspisode(episode)"
                    [style.color]="course.color"
                    class="number py-4 border border-transparent text-s font-bold text-uppercase text-line-3"
                >
                    {{ 'v3-global-li' | translate }}{{ i + 1 }}
                </div>
            </div>
            <div class="text-oneline w-100">
                <ng-container *ngFor="let episode of episodes; let i = index">
                    <ng-container *ngIf="episode.created; then new; else old"></ng-container>

                    <ng-template #old>
                        <div #element class="pb-1 element">
                            <div class="p-4 bg-dark text-muted border border-dark text-s font-bold rounded text-uppercase text-line-3 text-oneline">
                                {{ episode.name }}
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #new>
                        <div #element class="pb-1 element dragged">
                            <div
                                (dragstart)="onDragStart($event)"
                                (dragend)="onDragEnd($event)"
                                class="p-4 d-flex align-items-center g-0 bg-white text-default border border-dark text-s font-bold rounded text-uppercase text-line-3"
                                draggable="true"
                            >
                                <div class="icon icon-l icon-default me-4" inlineSVG="assets/icons.svg#content-{{ episode.type }}"></div>
                                <div class="col text-oneline">{{ episode.name }}</div>
                                <div class="icon icon-l icon-muted" inlineSVG="assets/icons.svg#dice-six"></div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!loaded" class="py-6">
    <app-loader loaderType="cover" overlayColor="white"></app-loader>
</div>
